import { Component, input, computed } from '@angular/core';
import { User } from '@app/core/stingray-api/models';
import { TranslateModule } from '@ngx-translate/core';
import { MatLine } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { MatListItem, MatListItemIcon } from '@angular/material/list';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'unite-audit-list-item',
    templateUrl: './audit-list-item.component.html',
    styleUrls: ['./audit-list-item.component.scss'],
    imports: [MatListItem, MatIcon, MatListItemIcon, MatLine, DatePipe, TranslateModule]
})
export class AuditListItemComponent {

  last = input(false);
  text = input<string>();
  author = input<User | string>();
  date = input<string>();
  icon = input('edit');

  authorLabel = computed(() => {
    const author = this.author();
    if (typeof author === 'string') {
      return author;
    } else if (author !== null) {
      if (author.middleName === null) {
        return author.firstName + ' ' + author.surname;
      } else {
        return author.firstName + ' ' + author.middleName + ' ' + author.surname;
      }
    } else {
      return '-';
    }
  });

}
  